import { Component, Input } from '@angular/core';

export interface IconData {
  icon: string,
  alt: string,
  title: string,
  description?: string
}

@Component({
  selector: 'kion-icon-bar',
  templateUrl: './icon-bar.component.html',
  styleUrls: ['./icon-bar.component.scss']
})
export class IconBarComponent {

  @Input() icons: IconData[];
  @Input()  scale: 'small' | 'medium' | 'large' | 'extra-large' | string = 'large';
  hideIcon: string[] = [];

  iconNotFound(icon: string) {
    if (this.hideIcon.indexOf(icon) === -1) {
      this.hideIcon.push(icon);
    }
  }
}
